/**
 * Logger condicional: só escreve no console em ambiente de desenvolvimento.
 * Evita vazar informações de debug em produção e reduz o bundle de logs.
 *
 * Uso:
 *   import { logger } from '@/lib/logger';
 *   logger.error('Erro ao buscar:', err);
 *   logger.warn('Atenção...');
 *   logger.info('Info');
 */
const isDev = process.env.NODE_ENV === 'development';

const noop = () => {};

export const logger = {
  log: isDev ? console.log.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  // Erros sempre são logados para facilitar suporte (mas sem dados sensíveis)
  error: console.error.bind(console),
};

export default logger;
